import { configureStore } from '@reduxjs/toolkit';
import { loggerModel } from '../../entities/Logger';
import { moodleModel } from '../../entities/Moodle';
import { adminModel } from '../../entities/Admin';
import { virtualKoteachModel } from '../../entities/VirtualKoteach';


export const store = configureStore({
    reducer: {
        logger: loggerModel.loggerSlice.reducer,
        moodle: moodleModel.moodleSlice.reducer,
        admin: adminModel.adminSlice.reducer,
        virtualKoteach: virtualKoteachModel.virtualKoteachSlice.reducer
    },
});